import { visionLabApi } from '@/app/apiClient';
import type { ApiCallOptions } from '@/shared/api/client';
import type { IntakeJob } from '../types/uploads';

/** `GET /intake-jobs/:id` — the async post-upload pipeline job. The id is the submission `sessionId`
 * (direct upload) or the `importId` (import), which the backend derives as the intake id 1:1. */
export async function getIntakeJob(
  intakeId: string,
  options: ApiCallOptions = {},
): Promise<IntakeJob> {
  return visionLabApi.get<IntakeJob>(`/intake-jobs/${encodeURIComponent(intakeId)}`, options);
}
